export default __webpack_public_path__ + "static/binance@2x-106c00434d71235cfc58dad5531f2204.png";